export default (props = {}) => {
	return {
		...props,
		form: {
			...props.form,
			headline: props.heading,
			services: ["SLP"],
			fields: props.form?.fields.map((field) => {
				if (field.id === "comments") {
					return {
						type: "TextAreaInput",
						name: field.id,
						label: field.label,
						errorMessage: field.errorMessage,
						required: false,
					};
				}
				return {
					type: "TextInput",
					name: field.id,
					label: field.label,
					errorMessage: field.errorMessage,
					validation: field.id,
					required: field.id !== "phone",
				};
			}),
		},
	};
};
